export default __webpack_public_path__ + "static/media/Harness of the Ichorus.9b941c60.jpg";